import React, { useState, useEffect } from "react";
import { DisasterAlert } from "./components/DisasterAlert";
import { DisasterDocumentDisplayCard } from "./components/DisasterDocumentDisplayCard";
import { DisasterListingCard } from "./components/DisasterListingCard";
import { DisasterInsuranceCard } from "./components/DisasterInsuranceCard";
import { DisasterMainTiles } from "./components/DisasterMainTiles";
import assetInfoIcon from "../../../../assets/images/n.png";
import PlanCalander from "./components/PlanCalander";
import { DisabilityLiabilityCard } from "../../disability/DisabilityDashboard/components/DisabilityLiabilityCard";
import axios from "axios";
import { FormPrintouts } from "./components/FormPrintouts";
import { MODULE_API } from "../../../../apis";
import FETCH from "../../../../utils/fetch";
import DASHBOARD_API from "../../../../apis/dashboard.api";
import { DisasterDocumentDisplayCardCommunication } from "./components/DisasterDocumentDisplayCardCommunication";
import ModalVideo from "../../../../newComponents/ModuleVideos/ModalVideo";
const API_KEY = "4e071f77b1364d48a9f174551231807"; // Replace with your real API key


export const DisasterDashboard = () => {
  const [tableData, setTableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [weatherData, setWeatherData] = useState(null);
  const [weatherCondtion, setWeatherCondtion] = useState(null);
  const [weatherLocation, setWeatherLocation] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [locationError, setLocationError] = useState(null);
  const [insuranceData, setInsuranceData] = useState([]);
  const [monetaryValue, setMonetaryValue] = useState(0);
  const [calanderData,setCalanderData] =useState([]);
  
  const [totalLoan, setTotalLoan] = useState(0);
  const [fileUpload, setFileUpload] = useState({
    createdAt: "2025-03-28T10:41:53.000Z",
    "Document Upload":
      "https://assets-planet.s3.eu-west-1.amazonaws.com/media/81a1f8e1-4c40-430e-b629-6ef833763e65.xlsx",
    "Uploaded File Name": "Disability Updates (2).xlsx",
  });
  const cardMessages = {
    "Personal & Family Information": {
      name: "Personal & Family Information",
      Purpose:
        "Establishes core identity details, essential medical needs, and family structure. Critical for emergency responders, evacuation centers, and reunification efforts during disasters.",
      tooltip: "Disaster_Personal_Family_Information",
    },
    "Insurance Coverage": {
      name: "Insurance Coverage",
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "Disaster_Insurance_Coverage",
    },
    "Home safety & Security": {
      name: "Home safety & Security",
      Purpose:
        "Documents crucial home systems and safety features. Enables quick utility shutoffs, fire suppression, and home security during emergencies.",
      tooltip: "Disaster_Home_Safety_Security",
    },
    "Professional Contacts": {
      name: "Professional Contacts",
      Purpose:
        "Documents current work status, income sources, and potential workplace accommodations. Critical for understanding financial impact, disability benefits, and potential career modifications.",
      tooltip: "",
    },
    "Communication plan": {
      name: "Communication plan",
      Purpose:
        "Establishes protocols for family connectivity during disruptions. Ensures coordination when normal communication channels are compromised.",
      tooltip: "Disaster_Communciation_Plan",
    },
    "Medical History": {
      name: "Medical History",
      Purpose:
        "Medical history is a comprehensive record of an individual's health journey, documenting past and current medical conditions, treatments, diagnoses, medications, surgeries, hospitalizations, allergies, and family medical background.",
      tooltip: "",
    },
    "Important document storage": {
      name: "Important document storage",
      Purpose:
        "Protects critical legal, identity, and personal records. Prevents devastating loss of difficult-to-replace documents that verify identity and ownership.",
      tooltip: "Disaster_Important_Document_Storage",
    },
    "Regular Plan Review Reminders": {
      name: "Regular Plan Review Reminders",
      Purpose:
        "Documents required physical modifications and adaptive technologies to maintain independence, functionality, and quality of life.",
      tooltip: "",
    },
    "Emergency contacts information": {
      name: "Emergency contacts information",
      Purpose:
        "Creates a network of communication channels and support resources. Ensures you can reach critical individuals and services when primary communication methods fail.",
      tooltip: "Disaster_Emergency_Contacts",
    },
    "Evacuation Planning": {
      name: "Evacuation Planning",
      Purpose:
        "Creates clear action pathways for leaving danger zones. Reduces critical decision-making during high-stress situations and increases evacuation success.",
      tooltip: "Disaster_Evacuation_Planning",
    },
    "Recovery plan": {
      name: "Recovery plan",
      Purpose:
        "Outlines steps for rebuilding and normalizing after disasters. Accelerates the return to stability by creating a roadmap for recovery actions.",
      tooltip: "Disaster_Recovery_Plan",
    },
    "Emergency Supplies Inventory": {
      name: "Emergency Supplies Inventory",
      Purpose:
        "Tracks essential survival resources and their locations. Ensures adequate preparation for periods of isolation or resource disruption.",
      tooltip: "Disaster_Emergency_Supplies_Inventory",
    },
    "Property Documentation": {
      name: "Property Documentation",
      Purpose:
        "Preserves proof of ownership and valuable asset details. Essential for insurance claims, damage assessment, and property recovery following disasters.",
      tooltip: "Disaster_Property_Documentation",
    },
  };
  const getInsuranceList = async () => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
         id: userRole === "Financial Advisor Client"
            ? `?module=Insurance Products V2&page=1&limit=50&clientId=${ID}`
            : `?module=Insurance Products V2&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        setInsuranceData(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getMonetaryValueAssets = async () => {
    try {
      setLoading(true);
      setMonetaryValue(0);
      const moduleName = "Assets";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (
        data &&
        data.data &&
        data.data[0] &&
        data.data[0].monetary &&
        data.data[0].monetary !== null
      ) {
        setMonetaryValue(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      console.log(data);
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const fetchWeatherAndAlerts = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://api.weatherapi.com/v1/forecast.json?key=${API_KEY}&q=${latitude},${longitude}&days=3&alerts=yes`
      );

      const data = response.data;
      if (data.current) {
        setWeatherData(data.current);
      }
      if (data.location) {
        setWeatherLocation(data.location);
      }
      if (data.alerts.alert) {
        setAlerts(data.alerts.alert || []);
      }
    } catch (error) {
      console.error("Error fetching weather data:", error);
    } finally {
      // setLoading(false);
    }
  };
  const moduleNames = [
    "Personal and Family Information",
    "Communication Plan",
    "Recovery Plan",
    "Home Safety And Security",
    "Important Document Storage",
    "Evacuation Planning",
    "Emergency Contacts",
    "Emergency Supplies Inventory",
    "Property Documentation",
  ];
  const fetchAllModulesData = async () => {
    try {
      setLoading(true);
      const results = await Promise.all(
        moduleNames.map((name) => fetchData(name))
      );
      console.log("All module results:", results);
      const primaryCaresGiverMod = results.find(
        (item) => item.moduleName === "Primary Caregivers"
      );
      if (primaryCaresGiverMod) {
        const targetRecord = primaryCaresGiverMod.records.find(
          (record) =>
            record.subType === "Disability" ||
            "Professional Care Provider" in record
        );
        // setFieldsData(targetRecord);
      } else {
        console.log("Medical History module not found");
      }

      const tableDataObj = results.reduce((acc, { moduleName, records }) => {
        acc[formatModuleKey(moduleName)] = records;
        return acc;
      }, {});

      setTableData(tableDataObj);
    } catch (error) {
      console.error("Error fetching all modules:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async (moduleName) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      const records = res.records || [];
      setLoading(false);
      return { moduleName, records }; // Return object with moduleName to map later
    } catch (error) {
      console.error(`Error fetching data for ${moduleName}:`, error);
      return { moduleName, records: [] }; // Return empty if failed
    } finally {
      setLoading(false);
    }
  };
  const formatModuleKey = (moduleName) => {
    return (
      moduleName &&
      moduleName
        .replace(/[^a-zA-Z ]/g, "") // Remove special chars
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
          index === 0 ? word.toLowerCase() : word.toUpperCase()
        )
        .replace(/\s+/g, "") + "Data"
    );
  };
  const getAll = async () => {
    await fetchAllModulesData();
    await getLiabilitySum();
    await getMonetaryValueAssets();
    await getInsuranceList();
  };
  useEffect(() => {
    getAll();
  }, []);
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          fetchWeatherAndAlerts(latitude, longitude);
        },
        (error) => {
          console.error("Geolocation error:", error);
          setLocationError("Location permission denied or unavailable.");
        }
      );
    } else {
      setLocationError("Geolocation is not supported by your browser.");
    }
  }, []);
  return (
    <div>
    <ModalVideo module="Disaster" autoOpen={true} />
      <div className="MainDisabilityDashboard">
        {alerts && alerts.length > 0 && (
          <div className="mainUpperContainer">
            <DisasterAlert
              weatherData={weatherData && weatherData}
              alerts={alerts && alerts}
              locationError={locationError && locationError}
              loading={loading}
            />
          </div>
        )}
        <div className="mainUpperContainer">
          <DisasterMainTiles
            weatherData={weatherData && weatherData}
            alerts={alerts && alerts}
            locationError={locationError && locationError}
            weatherCondtion={weatherCondtion && weatherCondtion}
            weatherLocation={weatherLocation && weatherLocation}
            setCalanderData={setCalanderData}
            loading={loading}
          />
        </div>
        <div className="mainUpperContainer">
          <div style={{ width: "70%" }}>
            <div
              className="main-disaster-cards-style"
              style={{ marginBottom: "0.8rem" }}
            >
              <DisasterDocumentDisplayCard
                step={0}
                moduleData={cardMessages["Personal & Family Information"]}
                fileUpload={fileUpload}
                documents={
                  tableData &&
                  tableData.personalAndFamilyInformationData &&
                  tableData.personalAndFamilyInformationData
                }
                loading={loading}
                width="33%"
              />
              <DisasterDocumentDisplayCardCommunication
                step={8}
                moduleData={cardMessages["Communication plan"]}
                documents={
                  tableData &&
                  tableData.communicationPlanData &&
                  tableData.communicationPlanData
                }
                fileUpload={fileUpload}
                loading={loading}
                width="33%"
              />
              <DisasterListingCard
                step={7}
                loading={loading}
                moduleData={cardMessages["Home safety & Security"]}
                dataList={
                  tableData && tableData.homeSafetyAndSecurityData
                    ? tableData.homeSafetyAndSecurityData
                    : []
                }
                width="33%"
              />
            </div>
            <div className="main-disaster-cards-style">
              <div className="DisabilityInsuarceCardMain">
                <DisasterInsuranceCard
                  dataList={insuranceData}
                  step={9}
                  moduleData={cardMessages["Insurance Coverage"]}
                  loading={loading}
                />
              </div>
              <DisasterListingCard
                step={10}
                loading={loading}
                moduleData={cardMessages["Recovery plan"]}
                dataList={
                  tableData && tableData.recoveryPlanData
                    ? tableData.recoveryPlanData
                    : []
                }
                width="33%"
              />
            </div>
          </div>
          <div style={{ width: "30%" }}>
            <PlanCalander calanderData={calanderData} />
          </div>
        </div>

        <div className="mainUpperContainer">
          <div style={{ width: "70%" }}>
            <div
              className="main-disaster-cards-style"
              style={{ marginBottom: "0.8rem" }}
            >
              <DisasterListingCard
                step={4}
                loading={loading}
                moduleData={cardMessages["Important document storage"]}
                dataList={
                  tableData && tableData.importantDocumentStorageData
                    ? tableData.importantDocumentStorageData
                    : []
                }
                width="33%"
              />
              <DisasterListingCard
                step={1}
                loading={loading}
                moduleData={cardMessages["Emergency contacts information"]}
                dataList={
                  tableData && tableData.emergencyContactsData
                    ? tableData.emergencyContactsData
                    : []
                }
                width="33%"
              />
              <DisasterListingCard
                step={6}
                loading={loading}
                moduleData={cardMessages["Evacuation Planning"]}
                dataList={
                  tableData && tableData.evacuationPlanningData
                    ? tableData.evacuationPlanningData
                    : []
                }
                width="33%"
              />
            </div>
            <div className="main-disaster-cards-style">
              <DisasterListingCard
                step={5}
                loading={loading}
                moduleData={cardMessages["Emergency Supplies Inventory"]}
                dataList={
                  tableData && tableData.emergencySuppliesInventoryData
                    ? tableData.emergencySuppliesInventoryData
                    : []
                }
                width="33%"
              />
              <DisabilityLiabilityCard
                loanAmount={totalLoan}
                monetaryValue={monetaryValue}
                loading={loading}
                Icon={assetInfoIcon}
                width="33%"
              />
              <DisasterListingCard
                step={2}
                loading={loading}
                moduleData={cardMessages["Property Documentation"]}
                dataList={
                  tableData && tableData.propertyDocumentationData
                    ? tableData.propertyDocumentationData
                    : []
                }
                width="33%"
              />
            </div>
          </div>
          <div style={{ width: "30%" }}>
            <FormPrintouts />
          </div>
        </div>
      </div>
    </div>
  );
};
